<login-alt-layout pageTitle="Terms of Use">
  <p>
    UNAUTHORIZED ACCESS TO THIS COMPUTER SYSTEM IS PROHIBITED BY LAW (REFERENCE
    TITLE 18 U.S.C., SECTION 1030)
  </p>

  <h3>CMS Controlled and Owned System</h3>

  <p>
    You are entering a Centers for Medicare &amp; Medicaid Services (CMS)
    computer system. This computer system is provided for the processing of
    Official U.S. Government information. This computer system, including all
    related equipment, networks, and network devices are provided only for
    authorized U.S. Government use. All data contained on this system is owned
    by CMS.
  </p>

  <h3>Monitoring of System Users</h3>

  <p>
    Users (authorized or unauthorized) have no explicit or implicit expectation
    of privacy. By using this system, the user consents to such interception,
    monitoring, recording, copying, auditing, inspection, and disclosure. Any or
    all uses of this system and all files on this system may be disclosed to an
    authorized site, CMS, and law enforcement personnel, as well as authorized
    officials of other agencies, both domestic and foreign. By continuing to use
    this system you indicate your awareness of and consent to these terms and
    conditions of use.
  </p>

  <h3>Responsibilities of System Users</h3>

  <p>
    IF YOU ARE NOT AUTHORIZED ACCESS TO THIS SYSTEM YOU MUST SIGN OUT
    IMMEDIATELY OR EXIT. Federal, State, and/or local laws may provide criminal
    penalties for any person illegally accessing or using a Government owned or
    operated computer system. Users must adhere to the
    <strong><em>CMS</em></strong> Information Security Policies, Standards, and
    Procedures; referred to as the CMS Information Security (IS) "Virtual
    Handbook" and can be found at
    <a href="http://www.cms.hhs.gov/InformationSecurity"
      >http://www.cms.hhs.gov/InformationSecurity</a
    >.
  </p>

  <h3>Privacy Act Warning</h3>

  <p>
    Information contained in this system is subject to the Privacy Act of 1974
    (5 U.S.C. 552A, as amended). Personal information contained in this system
    may be used only by authorized persons to conduct official business. Any
    individual responsible for unauthorized disclosure or misuse of personal
    information may be subject to monetary fines.
  </p>

  <h3>Health Insurance Portability and Accountability Act Warning</h3>

  <p>
    Individually identifiable health information in this system is subject to
    the Health Information Portability and Accountability Act of 1996 and the
    Department of Health and Human Services Privacy Rule in regard to that Act.
    This information may only be used and/or disclosed in strict conformance
    with authorized authorities. The healthcare quality organizations using this
    system are required to and will apply appropriate sanctions against
    individuals who fail to comply with its privacy policies and procedures.
  </p>

  <p>
    By continuing to use this system, you indicate your awareness of and consent
    to these Rules of Behavior, plus terms and conditions of use. SIGN OUT
    IMMEDIATELY if you do not agree to the conditions stated in this warning.
  </p>
</login-alt-layout>
